import React, { useState } from 'react';
import { observer } from 'mobx-react';
import '../../../../../scss/neurosales/common/cmsTopBar.scss';
import CMSButton from '../../../../generic/inputs/CMSButton';
import { useStore } from '../../../../../store/storeUtils';
import RemoveTilesModal from './RemoveTilesModal';
import { toJS } from 'mobx';
import { updateHomepageTilesTemplate } from '../../../../../utils/Utils';
const generateTemplate = numTiles => {
  return Array.from(Array(numTiles).keys()).map(a => {
    return /*#__PURE__*/React.createElement("div", {
      className: `single-element el-${a}`
    });
  });
};
const NeurosalesSelectTiles = observer(props => {
  const store = useStore();
  let currentConfiguration = toJS(store.previewConfiguration);
  if (!currentConfiguration || !currentConfiguration.configuration) {
    currentConfiguration = {
      configuration: {
        homePage: {
          boxes: []
        }
      },
      tool: 'Emotions'
    };
    store.setRenderPreviewConfiguration(currentConfiguration);
  }
  const [selectedTiles, setSelectedTiles] = useState(currentConfiguration.configuration.homePage.boxes.length);
  const [showModalRemoveTiles, setShowModalRemoveTiles] = useState(false);
  const setSelected = num => {
    setSelectedTiles(num);
  };
  const singleTilesTemplate = numTiles => {
    return /*#__PURE__*/React.createElement("div", {
      className: `tiles-template ${selectedTiles === numTiles ? 'selected' : ''}`,
      onClick: () => setSelected(numTiles)
    }, /*#__PURE__*/React.createElement("div", {
      className: `tiles-container elements-${numTiles}`
    }, generateTemplate(numTiles)), /*#__PURE__*/React.createElement("div", {
      className: "tiles-name"
    }, numTiles, " cards"));
  };
  const checkToGenerate = () => {
    let newConfiguration = currentConfiguration.configuration;
    if (selectedTiles > newConfiguration.homePage.boxes.length) {
      const howManyToAdd = selectedTiles - newConfiguration.homePage.boxes.length;
      for (let i = 1; i <= howManyToAdd; i++) {
        let tileNumber = 0;
        newConfiguration.homePage.boxes.forEach(t => {
          if (t.index > tileNumber) {
            tileNumber = t.index;
          }
        });
        tileNumber += 1;
        newConfiguration.homePage.boxes.push({
          component: 'NoComponent',
          navigation: `/card-${tileNumber}`,
          image: '/CMS/img/empty_box_image.svg',
          icon: '',
          title: `Card ${tileNumber}`,
          dimension: 1,
          flagComingSoon: false,
          flagExternalLink: false,
          index: tileNumber,
          exact: true,
          visible: true,
          componentParams: {}
        });
      }
      generateConfiguration({
        ...currentConfiguration,
        configuration: {
          ...newConfiguration
        }
      });
    } else {
      setShowModalRemoveTiles(true);
    }
  };
  const removeCards = cardsToDelete => {
    let tiles = currentConfiguration.configuration.homePage.boxes;
    tiles = tiles.filter((_, index) => {
      return !cardsToDelete.includes(index);
    });
    generateConfiguration({
      configuration: {
        ...currentConfiguration.configuration,
        homePage: {
          boxes: tiles
        }
      }
    });
  };
  const generateConfiguration = conf => {
    const tiles = updateHomepageTilesTemplate(conf.configuration.homePage.boxes);
    const newConfiguration = {
      ...conf,
      configuration: {
        ...conf.configuration,
        homePage: {
          boxes: tiles
        }
      }
    };
    store.setRenderPreviewConfiguration(newConfiguration);
    store.synchronizeWholeConfiguration();
    closePage();
  };
  const closePage = () => {
    if (props.setSelectPageTiles) {
      props.setSelectPageTiles(false);
    }
    if (props.firstStart) {
      props.setFirstStart(false);
      if (props.setSettingsPage) {
        props.setSettingsPage(true);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cms-select-tiles-page cms-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-select-tiles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-iniziativa"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nome-iniziativa"
  }, props.projectInfo.displayName), /*#__PURE__*/React.createElement("div", {
    className: "payoff-iniziativa"
  }, props.projectInfo.payoff)), /*#__PURE__*/React.createElement("div", {
    className: "info-select-tiles"
  }, currentConfiguration && currentConfiguration.configuration && currentConfiguration.configuration.homePage && currentConfiguration.configuration.homePage.boxes && currentConfiguration.configuration.homePage.boxes.length > 0 ? 'Quante tiles desideri?' : 'Inizia a customizzare il tuo progetto, quante tiles desideri?'), /*#__PURE__*/React.createElement("div", {
    className: "tiles-templates"
  }, /*#__PURE__*/React.createElement("div", {
    className: "first-row"
  }, singleTilesTemplate(4), singleTilesTemplate(5), singleTilesTemplate(6), singleTilesTemplate(7)), /*#__PURE__*/React.createElement("div", {
    className: "second-row"
  }, singleTilesTemplate(8), singleTilesTemplate(9), singleTilesTemplate(10), singleTilesTemplate(11), singleTilesTemplate(12))), /*#__PURE__*/React.createElement("div", {
    className: "container-buttons"
  }, /*#__PURE__*/React.createElement(CMSButton, {
    disabled: !props.modifyPageTiles,
    className: "button-annulla",
    inverted: true,
    onClick: () => closePage()
  }, "Annulla"), /*#__PURE__*/React.createElement(CMSButton, {
    disabled: selectedTiles === -1 || currentConfiguration && currentConfiguration.configuration && currentConfiguration.configuration.homePage && currentConfiguration.configuration.homePage.boxes && currentConfiguration.configuration.homePage.boxes.length === selectedTiles,
    className: "button-crea",
    onClick: () => checkToGenerate()
  }, "Crea"))), currentConfiguration ? /*#__PURE__*/React.createElement(RemoveTilesModal, {
    open: showModalRemoveTiles,
    handleClose: cardsToDelete => {
      removeCards(cardsToDelete);
    },
    handleCancel: () => setShowModalRemoveTiles(false),
    cards: currentConfiguration && currentConfiguration.configuration && currentConfiguration.configuration.homePage ? currentConfiguration.configuration.homePage.boxes : [],
    targetNumber: selectedTiles
  }) : null);
});
export default NeurosalesSelectTiles;